import { topicTags } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

const typeClass: Record<string, string> = {
  primary: "bg-primary-500 text-background-50 border-primary-500 hover:bg-primary-600",
  accent: "bg-accent-500 text-background-50 border-accent-500 hover:bg-accent-600",
  plain:
    "bg-background-50 text-foreground-700 border-background-300 hover:border-primary-300 hover:text-primary-600",
};

export default function TopicWall() {
  return (
    <section id="topics" className="border-y border-background-200/70 bg-background-100">
      <div className="container-x py-10 md:py-14">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            kicker="按话题挑瓜"
            title="话题墙 · 想吃哪个点哪个"
            desc="猛料汇总按主题分好，颜色块表示热度档：红=正在发酵、绿=有新补充，灰线=常驻归档。点开即可切到对应合集。"
          />
          <a
            href="#heji"
            className="mb-5 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700 md:mb-7 whitespace-nowrap"
          >
            浏览全部合集<i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center gap-2.5">
          {topicTags.map((t) => (
            <a
              key={t.text}
              href="#shilu"
              className={`inline-flex items-center gap-1.5 rounded-full border px-3.5 py-1.5 text-sm font-medium transition-colors whitespace-nowrap ${typeClass[t.type]}`}
            >
              <i className="ri-hashtag text-xs"></i>
              {t.text}
            </a>
          ))}
        </div>

        {/* quick index row */}
        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
          {[
            { n: "128", l: "实锤确认", i: "ri-checkbox-circle-line" },
            { n: "64", l: "存疑跟进", i: "ri-time-line" },
            { n: "39", l: "今日新更", i: "ri-flashlight-line" },
            { n: "213", l: "归档合集", i: "ri-folder-5-line" },
          ].map((s) => (
            <div
              key={s.l}
              className="flex items-center gap-3 rounded-xl border border-background-200 bg-background-50 px-4 py-3.5"
            >
              <span className="grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className={`${s.i} text-lg`}></i>
              </span>
              <span>
                <span className="block font-heading text-xl font-extrabold text-foreground-950">{s.n}</span>
                <span className="text-xs text-foreground-500">{s.l}</span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}